import { Button } from '@mantine/core';
import { ContextModalProps } from '@mantine/modals';
import { IconCalendarEvent, IconCheck } from '@tabler/icons-react';

import styles from './BookDemoModal.module.scss';
import { Props } from './BookDemoModal.types';

const BOOKING_URL =
  'https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ1VB1wEwjVSornOydaW-btRHCVr6Mb4bejjOJ1ukpKc1rwV1_HcMVjBBIc1yhzjt9HH_RxIkCsS';

const BookDemoModal = ({ context, id, innerProps }: ContextModalProps<Props>) => {
  const closeAndSkip = () => {
    innerProps.onSkip?.();
    context.closeModal(id);
  };

  const handleBook = () => {
    window.open(BOOKING_URL, '_blank', 'noopener,noreferrer');
    innerProps.onBook?.();
    context.closeModal(id);
  };

  return (
    <div className={styles.container}>
      <div className={styles.iconWrapper}>
        <span className={styles.icon} role="img" aria-label="hand wave">
          👋
        </span>
      </div>

      <h2 className={styles.title}>Bienvenue sur ShareHeritage</h2>
      <div className={styles.subtitle}>Démarrons ensemble sur le bon pied</div>

      <p className={styles.body}>
        Alexis, fondateur de ShareHeritage, vous offre une{' '}
        <strong className={styles.highlight}>démo personnalisée de 10 min en visio</strong> pour
        configurer votre espace en moins de temps qu&apos;il n&apos;en faut pour faire un café.
      </p>

      <ul className={styles.bullets}>
        <li>
          <IconCheck size={18} className={styles.bulletIcon} />
          <span>Tour guidé adapté à votre situation</span>
        </li>
        <li>
          <IconCheck size={18} className={styles.bulletIcon} />
          <span>Réponses à toutes vos questions sur votre bien familial</span>
        </li>
        <li>
          <IconCheck size={18} className={styles.bulletIcon} />
          <span>Aucun engagement, juste 10 min</span>
        </li>
      </ul>

      <Button
        fullWidth
        size="md"
        className={styles.cta}
        leftSection={<IconCalendarEvent size={18} />}
        onClick={handleBook}
      >
        Réserver ma démo (10 min)
      </Button>

      <button type="button" className={styles.skip} onClick={closeAndSkip}>
        Plus tard
      </button>
    </div>
  );
};

export default BookDemoModal;
